import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=497cc6bd"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"
import style0 from "./UsersList.vue?vue&type=style&index=0&id=497cc6bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports